import React from 'react'
import { useTranslation } from '@/shared/contexts/TranslationContext'

export function PlaceholderPage({ title }: { title: string }) {
  const { t } = useTranslation()
  // Title passed is expected to be already translated by caller when needed.
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <svg className="w-16 h-16 text-amber-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
      </svg>
      <h1 className="text-2xl font-bold text-slate-800 dark:text-white mb-2">{title}</h1>
      <p className="text-slate-500 dark:text-slate-400">{t('common.page_under_construction') || 'Página em construção'}</p>
    </div>
  )
}
